import type { AdmissionPreAuthStatusDto } from '@his/shared';
import { tr } from '@/lib/i18n-core';
import { money } from '@/lib/utils';
import type { Admission } from './types';

export type PreAuthState = 'self_pay' | 'not_required' | 'approved' | 'pending' | 'needed' | 'unknown';

export function preAuthState(admission: Pick<Admission, 'payer'>, status: AdmissionPreAuthStatusDto | undefined): PreAuthState {
  if (!admission.payer) return 'self_pay';
  if (!status) return 'unknown';
  if (!status.required) return 'not_required';
  if (status.satisfied) return 'approved';
  return status.pendingCount > 0 ? 'pending' : 'needed';
}

export interface DischargeCheck {
  key: string;
  ok: boolean;
  label: string;
}

export function dischargeChecks(admission: Pick<Admission, 'openWork' | 'account' | 'bedChargeConfigured'>): DischargeCheck[] {
  const work = admission.openWork ?? { labItems: 0, radiology: 0, dueDoses: 0 };
  const owing = admission.account.balanceMinor < 0 ? Math.abs(admission.account.balanceMinor) : 0;
  return [
    { key: 'lab', ok: work.labItems === 0, label: work.labItems === 0 ? tr('ipd', 'ws_check_lab_done') : tr('ipd', 'ws_check_lab_open', { count: work.labItems }) },
    { key: 'radiology', ok: work.radiology === 0, label: work.radiology === 0 ? tr('ipd', 'ws_check_imaging_done') : tr('ipd', 'ws_check_imaging_open', { count: work.radiology }) },
    { key: 'doses', ok: work.dueDoses === 0, label: work.dueDoses === 0 ? tr('ipd', 'ws_check_doses_done') : tr('ipd', 'ws_check_doses_open', { count: work.dueDoses }) },
    { key: 'account', ok: owing === 0, label: owing === 0 ? tr('ipd', 'ws_check_account_settled') : tr('ipd', 'ws_check_account_owing', { amount: money(owing) }) },
    ...(admission.bedChargeConfigured === false ? [{ key: 'bed', ok: false, label: tr('ipd', 'this_bed_has_no_bed_day_charge') }] : []),
  ];
}
